<template>
  <div class="partialReturnList">
    <p class="partialReturnListTitle">{{tdc.tdc_partialReturnListTitle.toUpperCase()}}</p>
    <div v-if="qualifications.length === 0" class="noReturnsFound">{{tdc.tdc_noReturnsFound}}</div>
    <ProductReturnCard
      v-else
      v-for="qualification in qualifications"
      :defaultName="tdc.tdc_unidentifiedQualificationSharer"
      :index="index"
      :key="qualification.id"
      :partialReturnList="partialReturnList"
      :qualification="qualification"
      @select="select"
      :quantityLabel="tdc.tdc_quantityLabel"
    />
  </div>
</template>

<script>
import config from '../../js/qualificationsConfigService'
import ProductReturnCard from './ProductReturnCard.vue'
export default {
  components: {
    ProductReturnCard,
  },
  data() {
    return {
      tdc_partialReturnListTitle: '',
      tdc_noReturnsFound: '',
      tdc_unidentifiedQualificationSharer: '',
      tdc_quantityLabel: '',
      tdc: config.getTdc(),
    }
  },
  methods: {
    select(event) {
      this.$emit('update-partial-return-list', {
        [event.sku]: event.selectedQuantities
      })
    },
  },
  props: {
    qualifications: {
      type: Object,
    },
    partialReturnList: {
      type: Object,
    },
  },
}
</script>

<style lang="scss">
  .partialReturnList {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      width: 100%;
      height: 100%;
      overflow-y: scroll;
      .partialReturnListTitle {
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 15px;
      }
    }
</style>
